import * as actions from "../actions";

const initialState = {
  username: "",
  isImpersonating: false,
  calculatedPermissions: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    //USER ACTIONS
    case actions.UPDATE_USER:
      action.payload.user.calculatedPermissions = {};
      action.payload.user.permissionList.forEach((permission) => {
        action.payload.user.calculatedPermissions[permission] = true;
      });
      return action.payload.user;
    default:
      return state;
  }
};

export default reducer;
